import React, { useEffect, useState } from "react";
import "./Draw_Details.css";
import Message_Modal from "../../common_components/common_modal/message_modal/Message_Modal";
import { Table } from "react-bootstrap";
import {
  AllFunTargetResult,
  AllRouletteResult,
} from "../../../features/common/Slice";
import { useDispatch, useSelector } from "react-redux";

const Draw_Details = () => {
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(true);

  // ==========================================
  // PAGINATION
  // ==========================================
  const [funTargetPage, setFunTargetPage] = useState(1);
  const [roulettePage, setRoulettePage] = useState(1);

  const perPage = 10;

  const funTargetResultData = useSelector(
    (state) => state.common.all_fun_target_result,
  );

  const rouletteResultData = useSelector(
    (state) => state.common.all_roulette_result,
  );

  // ==========================================
  // API CALL - FUN TARGET
  // ==========================================
  useEffect(() => {
    dispatch(
      AllFunTargetResult({
        page: funTargetPage,
        per_page: perPage,
      }),
    );
  }, [dispatch, funTargetPage]);

  // ==========================================
  // API CALL - ROULETTE
  // ==========================================
  useEffect(() => {
    dispatch(
      AllRouletteResult({
        page: roulettePage,
        per_page: perPage,
      }),
    );
  }, [dispatch, roulettePage]);

  // ==========================================
  // REFRESH
  // ==========================================
  const handleRefresh = () => {
    setFunTargetPage(1);
    setRoulettePage(1);

    dispatch(
      AllFunTargetResult({
        page: 1,
        per_page: perPage,
      }),
    );

    dispatch(
      AllRouletteResult({
        page: 1,
        per_page: perPage,
      }),
    );
  };

  // ==========================================
  // DATE FORMAT
  // ==========================================
  const formatDate = (date) => {
    if (!date) return "-";

    return new Date(date)
      .toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      })
      .replace(",", "")
      .toUpperCase();
  };

  // ==========================================
  // PAGINATION DATA
  // ==========================================
  const funTargetData = funTargetResultData?.data || [];
  const rouletteData = rouletteResultData?.data || [];

  const funTargetTotal =
    funTargetResultData?.total || funTargetResultData?.pagination?.total || 0;

  const rouletteTotal =
    rouletteResultData?.total || rouletteResultData?.pagination?.total || 0;

  const funTargetTotalPages = Math.ceil(funTargetTotal / perPage);
  const rouletteTotalPages = Math.ceil(rouletteTotal / perPage);

  return (
    <section className="Draw_Details">
      {/* ==========================================
          REFRESH
      ========================================== */}
      <div className="refresh_btn_holder">
        <button type="button" className="blue_btn" onClick={handleRefresh}>
          Refresh
        </button>
      </div>

      <div className="all_tables_holder">
        <div className="row me-0 ms-0">
          {/* ==========================================
              FUN TARGET
          ========================================== */}
          <div className="col-xl-6 col-sm-6">
            <div className="game_table">
              <div className="table_header">Fun Target</div>

              <div className="table-responsive fixed-height-scroll">
                <Table className="custom_table">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>Draw No.</th>
                      <th>Draw Time</th>
                    </tr>
                  </thead>

                  <tbody>
                    {funTargetData.length > 0 ? (
                      funTargetData.map((row, i) => (
                        <tr key={row.id || i}>
                          <td>{(funTargetPage - 1) * perPage + i + 1}</td>

                          <td>{row.result}</td>

                          <td>{formatDate(row.createdAt)}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center">
                          No data found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>

              {/* FUN TARGET PAGINATION */}
              {funTargetTotalPages > 1 && (
                <div className="pagination_holder">
                  <button
                    type="button"
                    disabled={funTargetPage === 1}
                    onClick={() => setFunTargetPage((prev) => prev - 1)}
                  >
                    Previous
                  </button>

                  <span>
                    Page {funTargetPage} of {funTargetTotalPages}
                  </span>

                  <button
                    type="button"
                    disabled={funTargetPage === funTargetTotalPages}
                    onClick={() => setFunTargetPage((prev) => prev + 1)}
                  >
                    Next
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* ==========================================
              ROULETTE
          ========================================== */}
          <div className="col-xl-6 col-sm-6">
            <div className="game_table">
              <div className="table_header">Roulette</div>

              <div className="table-responsive fixed-height-scroll">
                <Table className="custom_table">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>Draw No.</th>
                      <th>Draw Time</th>
                    </tr>
                  </thead>

                  <tbody>
                    {rouletteData.length > 0 ? (
                      rouletteData.map((row, i) => (
                        <tr key={row.id || i}>
                          <td>{(roulettePage - 1) * perPage + i + 1}</td>

                          <td>{row.Roulette_Number?.number ?? "-"}</td>

                          <td>{formatDate(row.createdAt)}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center">
                          No data found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>

              {/* ROULETTE PAGINATION */}
              {rouletteTotalPages > 1 && (
                <div className="pagination_holder">
                  <button
                    type="button"
                    disabled={roulettePage === 1}
                    onClick={() => setRoulettePage((prev) => prev - 1)}
                  >
                    Previous
                  </button>

                  <span>
                    Page {roulettePage} of {rouletteTotalPages}
                  </span>

                  <button
                    type="button"
                    disabled={roulettePage === rouletteTotalPages}
                    onClick={() => setRoulettePage((prev) => prev + 1)}
                  >
                    Next
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Message_Modal show={showModal} onHide={() => setShowModal(false)} />
    </section>
  );
};

export default Draw_Details;
